var Intesa = Intesa || {};

Intesa.MerchantList = function () {
    var merchantList = this;
    var origTables;
    var condensedList = [];
    var labels;
    var MCCLabels;
    const table = $("div[data-type-table-merchant=Merchant]");
    this.defaultInstallments = [12, 6, 3, 9, 18, 24];
    var originalText;
    this.debitArr = [3, 6, 9, 12];
    this.creditArr = [3, 6, 9, 12, 18, 24];
    this.condensedListAnalysis = [];
    if($('#select-card-placeholder').length > 0){
    	originalText = $('#select-card-placeholder')[0].innerHTML;
    }
    merchantList.filtered = {};

    this.init = function () {
        const bank = $("html").attr("data-bank");
        if (bank == "BIB") {
            try {
                labels = JSON.parse($("#calculatorLabels").val());
                MCCLabels = JSON.parse($("#MCCLabels").val());
                var tables = $("div[data-type-table-merchant]");
                origTables = tables.clone();
                $(tables).each(function (index) {
                    var table = $(this);
                    var tableType = table.attr("data-type-table-merchant");
                    merchantList.createTableMerchant(tableType);
                });
            } catch (e) {
                console.log("can't start merchant, if you are in the correct page check configuration, if you are in another page ignore this error" + e);
            }
        }
        $('#installment').prop('checked', true);
        $('#physical').prop('checked', true);
        $('#online').prop('checked', true);
        $("input[name=all]").prop("checked", true);
        $("#show-extra").click();//DPP-484 fix
    };

    this.installmentString = function (installmentValue) {
        if (installmentValue > 3) {
            return labels.INSTALLMENTS;
        } else {
            return labels.INSTALLMENT;
        }
    };

    this.addElementsToTable = function (collection, table, from, to) {
        var tbody = table.find("tbody");
        var thead = table.find("thead");
        var totalColumns = thead.find(".tbl__highlistValue").length;
        // elem = array contente tutti gli elementi raggrupparti precedentemente
        collection.forEach(function (elem, index) {
            if (index >= from && index < to) {
                tbody = table.find("tbody");
                var tr = document.createElement("tr");
                var valueResult = "";
                var brands = Array.from(elem.Brand);

                for (i = 0; i < totalColumns - 1; i++) {
                    // prendo sempre il primo elemento (0) perché sono tutti uguali tranne per la colonna "Brand"
                    switch (i) {
                        case 0:
                        	// + " " + elem.RetailerName2
                            valueResult = elem.RetailerName1;
                            valueResult = valueResult.toUpperCase()
                            break;
                        // Store Address: city + address
                        case 1:
                            if (elem.TerminalType == "Internet") {
                                valueResult = elem.RetailerName2;
                            } else {
                                valueResult =
                                    elem.RetailerCityName +
                                    " " +
                                    elem.RetailerAddressLine1;
                            }
                            valueResult = valueResult.toUpperCase()
                            break;
                        // Accepted cards: list of the cards that are accepted
                        case 2:
                            valueResult = "";
                            brands.forEach(function (elem) {
                                valueResult +=
                                    '<img alt = "" aria-hidden = "true" class="creditCardIcon" src="'+window.location.origin+'/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/ico_small/' +
                                    elem +
                                    '.png"/> ';
                            });
                            break;
                        // Maximum number of installments
                        case 3:
                        	var brandsToCheck = new Set(brands);
                        	if(elem.InstNoMaxD != undefined && (elem.InstNoMaxD < 18 && (brandsToCheck.has("DINA") || brandsToCheck.has("Visa")))){
                            valueResult =
                                labels.MAX +
                                " " +
                                elem.InstNoMaxD +
                                " " +
                                merchantList.installmentString(elem.InstNoMaxD);
                        	} else {
                        		valueResult = "";
                        	}
                            break;
                        case 4:
                            valueResult =
                                labels.MAX +
                                " " +
                                elem.InstNoMaxC +
                                " " +
                                merchantList.installmentString(elem.InstNoMaxC);
                            break;
                        default:
                            valueResult = "";
                            break;
                    }

                    var td = document.createElement("td");
                    if (i === 3 || i === 4) {
                        var container = document.createElement("div");
                        container.classList.add("cards-container");
                        var mainElem = elem;
                        brands.forEach(function (elem) {
                        	if(i === 4 && elem.toLowerCase() != "dina"){
	                            var img = document.createElement("img");
	                            img.classList.add("creditCardIcon");
	                            img.src =
	                                ""+window.location.origin+"/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/ico_small/" +
	                                elem +
	                                ".png";
	                            container.append(img);
                        	} else if(i === 3 && elem.toLowerCase() != "amex" && elem.toLowerCase() != "mastercard" && (mainElem.InstNoMaxD != undefined && mainElem.InstNoMaxD < 18)) {
                                var img = document.createElement("img");
                                img.classList.add("creditCardIcon");
                                img.src =
                                    ""+window.location.origin+"/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/ico_small/" +
                                    elem +
                                    ".png";
                                container.append(img);
                        	}
                        });
                        td.append(container);
                        var text = document.createElement("span");
                        text.innerText = valueResult;
                        td.append(text);
                        td.classList.add("numberinstall-cell");
                        i === 3 ? td.classList.add("debit-cell") : td.classList.add("credit-cell");
                    } else {
                        td.innerHTML = valueResult;
                    }
                    if (i === 0 || i === 1) {
                        td.classList.add("text-cell");
                    }
                    td.classList.add("value-cell");
                    tr.append(td);
                }

                tbody.append(tr);
            }

            $("tbody")
                .find("tr")
                .each(function (index, elem) {
                    if (index % 2 != 0) {
                        elem.children[0].classList.add("store-name");
                    }
                });
        });
    };

    this.createTableMerchant = function (tableType) {
        const table = $("div[data-type-table-merchant=" + tableType + "]");
        const json = $("#merchant-list").val();

        if (json != "" && tableType == "Merchant") {
            var obj = JSON.parse(json);
            var merchantsInfoContainer =
                obj.fileContent[0].ExactFile.Records.RAcqInstallmentRange;

            // ragruppo il JSON di risposta per indirizzi e nome uguali.
            var condensed = [];
            var arr = [];
            var count = 0;
            var prev = null;
            merchantsInfoContainer.forEach(function (elem, index) {
                if (index == 0) {
                    condensed[count] = elem;
                    prev = elem;
                    arr.push(elem.Brand);
                } else {
                    var toAdd =
                        prev.CustomerName1 == elem.CustomerName1 &&
                        prev.CustomerName2 == elem.CustomerName2 &&
                        prev.RetailerAddressLine1 == elem.RetailerAddressLine1 &&
                        prev.RetailerCityName == elem.RetailerCityName;
                	
                    if (toAdd) {
                        index == merchantsInfoContainer.length - 1 ? condensed[count].Brand = new Set(arr) : arr.push(elem.Brand)
                    } else {
                        condensed[count].Brand = new Set(arr);
                        arr = [];
                        count++;
                        condensed[count] = elem;
                        arr.push(elem.Brand);
                        prev = elem;
                    }
                    
                }
            	if(elem.CardType == "C"){
            		condensed[count]["InstNoMaxC"] =  elem.InstNoMax;
            	} else if (elem.CardType == "D"){
            		condensed[count]["InstNoMaxD"] =  elem.InstNoMax;
            	}
            });
            condensedList = condensed;
            merchantList.condensedListAnalysis = condensed;
            merchantList.addElementsToTable(condensed, table, 0, 10);
            merchantList.populate(condensed);
        }
    };

    this.geStoresByName = function (name, collection) {
        if (name != "" && name != null) {
            collection = collection.filter(function (elem) {

                // passato dal nome nella collection
            	// " " + elem.RetailerName2
                var str = elem.RetailerName1;
                str = str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                // Passato dall'input
                name = name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                var replaceThis = name;
                var regexTest = new RegExp('\\b'+replaceThis+'\\b', 'g');
                if (regexTest.test(str)) {
                	console.log("filtered name " + name);
                    return elem;
                } else if(str.indexOf(name) >= 0){
                	if(!str.charAt((str.indexOf(name) - 1)).match(/[a-zA-Z]/i)){
                    	console.log("filtered name " + name);
                        return elem;
                	}
                }
            });
        }
        return collection;
    };

    // reutrns and sets a JSON file containing all the elements that match the expression
    this.getStoresByPlace = function (city, address, collection) {
    	//quando city == '' cerco per tutte le città
//        const conditions =
//            city != undefined &&
//            city != null &&
//            address != undefined &&
//            (city != "" || address != "");
//        if (conditions) {
            collection = collection.filter(function (elem) {
                var str =
                    elem.RetailerAddressLine1 + " " + elem.RetailerCityName;
                str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                
                if(city != null && city != undefined)
                city = city.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                
                if(address != null && address != undefined)
                address = address.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                
                // se sono popolati entrambi compreso city = '' cerco per entrambi
                if(address != null && address != undefined && city != null && city != undefined && address != ""){
	                console.log("condizione per entrambi");
                	if (str.includes(city) && str.includes(address)) {
                		console.log("condizione per entrambi" + str + " " + address);
	                    return elem;
	                }
                }
                // cerco solo per address
                else if (address != null && address != undefined && address != "" && (city == null || city == undefined)) {
                	console.log("condizione solo per address");
                	if (str.includes(address)) {
                		console.log("condizione solo per address" + str + " " + address);
	                    return elem;
	                }
                } 
                //cerco solo per city
                else if ((address == null || address == undefined || address == "") && city != null && city != undefined){
                	console.log("condizione solo per city");
                	if (str.includes(city)) {
                		console.log("condizione solo per city" + str + " " + address);
	                    return elem;
	                }
                }
            });
//        }
        return collection;
    };

    this.getStoresByType = function (typeMCC, typeCheck, collection) {
        const online = typeCheck.online;
        const physical = typeCheck.physical;
        const ifMCC = (typeMCC != "" && typeMCC != null && typeMCC.length > 0);
        var typeMCCArray = [];

        if (typeMCC != null) {
            if (typeMCC.indexOf(",") > -1) {
                typeMCCArray = typeMCC.split(",");
            } else {
                typeMCCArray.push(typeMCC);
            }
        }

        collection = collection.filter(function (elem) {
            if (online && !physical) {
                if (
                    ($.inArray(elem.MCC.toString(), typeMCCArray) > -1 || !ifMCC) &&
                    elem.TerminalType == "Internet"
                ) {
                    return elem;
                }
            }
            else if (physical && !online) {
                if (
                    ($.inArray(elem.MCC.toString(), typeMCCArray) > -1 || !ifMCC) &&
                    elem.TerminalType != "Internet"
                ) {
                    return elem;
                }
            }
            else {
                if ($.inArray(elem.MCC.toString(), typeMCCArray) > -1 || !ifMCC) {
                    return elem;
                }
            }

        });

        return collection;
    };

    this.getStoresByAcceptedCards = function (filterCards, collection) {
        if (filterCards != undefined && filterCards.length != 0) {
            collection = collection.filter(function (elem) {
                acceptedCards = Array.from(elem.Brand);
                var hasAllElems = true;

                for (var i = 0; i < filterCards.length && hasAllElems; i++) {
                    if (acceptedCards.indexOf(filterCards[i]) === -1) {
                        hasAllElems = false;
                    }
                }
                if (hasAllElems) {
                    return elem;
                }
            });
        }
        return collection;
    };

    this.getStoresByInstallmentPayments = function (
        installment,
        installmentCheck,
        collection
    ) {
        check = installmentCheck.credit || installmentCheck.debit;
        if ((installment != "" && installment != null) || check) {
            if (
                installment != "" &&
                installment != null &&
                installment != undefined
            ) {
                collection = collection.filter(function (elem) {
                	console.log("elem.InstNoMaxD " + elem.InstNoMaxD + "elem.InstNoMaxC " + elem.InstNoMaxC);
                    if (installmentCheck.allInstallments || (installmentCheck.credit && installmentCheck.debit) || (!installmentCheck.credit && !installmentCheck.debit)) {
                        if (elem.InstNoMaxD == installment || elem.InstNoMaxC == installment) {
                            return elem;
                        }
                    }
                    if (installmentCheck.credit && !installmentCheck.debit) {
                        if (elem.InstNoMaxC == installment) {
                            return elem;
                        }
                    }
                    if (installmentCheck.debit && !installmentCheck.credit) {
                        if (elem.InstNoMaxD == installment) {
                            return elem;
                        }
                    }
                });
            } else {
                collection = collection.filter(function (elem) {
                    if (installmentCheck.allInstallments || (installmentCheck.credit && installmentCheck.debit) || (!installmentCheck.credit && !installmentCheck.debit)) {
                        return elem;
                    }
                    if (installmentCheck.credit && !installmentCheck.debit) {
                        return elem;
                    }
                    if (installmentCheck.debit && !installmentCheck.credit) {
                        return elem;
                    }
                });
            }
        }
        return collection;
    };

    this.hideShowCards = function () {
        const debitChecked = $("#debit").prop("checked");
        const creditChecked = $("#credit").prop("checked");

        if (creditChecked) {
            if (debitChecked) {
                $(".debit-cell").css("visibility", "");
                $(".credit-cell").css("visibility", "");
            } else {
                $(".credit-cell").css("visibility", "");
                $(".debit-cell").css("visibility", "hidden");
            }
        }
        if (!creditChecked) {
            if (debitChecked) {
                $(".credit-cell").css("visibility", "hidden");
                $(".debit-cell").css("visibility", "");
            } else {
                $(".credit-cell").css("visibility", "");
                $(".debit-cell").css("visibility", "");
            }
        }
    };

    this.filter = function (name, city, address, tableType) {
        var table = $("div[data-type-table-merchant=" + tableType + "]");

        $(".section").find("tbody")[0].innerHTML = "";
        var filteredArray = [];
        filteredArray = merchantList.geStoresByName(name, condensedList);
        filteredArray = merchantList.getStoresByPlace(city, address, filteredArray);

        merchantList.addElementsToTable(filteredArray, table, 0, 10);

        return filteredArray;
    };

    this.extraFilter = function (tableType) {
        const chekboxes = Object.create({
            physical: $(".type-checkboxes").find("#physical").prop("checked"),
            online: $(".type-checkboxes").find("#online").prop("checked"),
            credit: $(".checkbox-list").find("#credit").prop("checked"),
            debit: $(".checkbox-list").find("#debit").prop("checked"),
            allInstallments: $(".checkbox-list")
                .find("#installment")
                .prop("checked"),
        });

        const cardsArray = Array.from(
            $(".cards-list").find("input[type=checkbox]")
        );
        var arr = [];
        cardsArray.forEach(function (checkbox) {
            if (checkbox.name != "all" && checkbox.checked) {
                arr.push(checkbox.name);
            }
        });

        var filteredArray = merchantList.filter(
            $("input[name=name]").val(),
            $("select[name=city-selector").val(),
            $("input[name=address").val(),
            tableType
        );

        filteredArray = merchantList.getStoresByType(
            $("select[name=type-selector]").val(),
            chekboxes,
            filteredArray
        );
        filteredArray = merchantList.getStoresByAcceptedCards(arr, filteredArray);
        filteredArray = merchantList.getStoresByInstallmentPayments(
            $("select[name=installments-selector]").val(),
            chekboxes,
            filteredArray
        );

        $(".section").find("tbody")[0].innerHTML = "";
        merchantList.addElementsToTable(filteredArray, table, 0, 10);

        merchantList.hideShowCards();

        return filteredArray;
    };

    this.clearFilters = function () {
        $(".extra-filters-wrapper").find("select").val("");
        $(".extra-filters-wrapper")
            .find('input[type="checkbox"')
            .each(function (index, elem) {
                $(elem).prop("checked", false);
            });
        $('#select-card-placeholder')[0].innerHTML = originalText
        merchantList.filtered = {}

    };

    this.populateSelector = function (collection, selector, attribute) {
        var arr = [];

        switch (attribute) {
            case "City":
                arr = $.map(collection, function (elem) {
                    var str = elem.RetailerCityName;
                    str = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                    return str;
                }).filter(function (cityName) {
                    var regex = /\d/g;
                    return !(regex.test(cityName)) 
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Novi Beograd".toLowerCase() 
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Banovo brdo".toLowerCase() 
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Zvezdara".toLowerCase() 
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Mali mokri lug".toLowerCase()
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Beograd-strai grad".toLowerCase()
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Beograd-vozdovac".toLowerCase()
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Beograd-zemun".toLowerCase()
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Nis-novo selo".toLowerCase()
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Beograd-savski venac".toLowerCase()
                    && cityName.toLowerCase() !== "Palic".toLowerCase()
                    && cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() !== "Zemun polje".toLowerCase()                    
                    ;
                });
                break;
            case "Installment":
                arr = merchantList.defaultInstallments;
                break;
            default:
                break;
        }

        arr = Array.from(new Set(arr));

        if (attribute == "Installment") {
            arr.sort(function (a, b) {
                if (a < b) { return -1; }
                if (a > b) { return 1; }
                return 0;
            });
            arr.forEach(function (elem, index) {
                $(selector).append(
                    $('<option value="' + elem + '">', { index: elem }).text(
                        labels.MAX +
                        " " +
                        elem +
                        " " +
                        merchantList.installmentString(elem)
                    )
                );
            });
        } else {
            arr.sort(function (a, b) {
                var nameA = a.toUpperCase();
                var nameB = b.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            arr.forEach(function (elem, index) {
                $(selector).append(
                    $('<option value="' + elem + '">', { index: elem }).text(
                        elem.toUpperCase()
                    )
                );
            });
        }
    };

    this.populateCardsSelector = function (collection) {
        var arr = [];

        collection.forEach(function (elem) {
            var array = Array.from(elem.Brand);
            array.forEach(function (card) {
                arr.push(card);
            });
        });
        arr = [new Set(arr)];

        arr[0].forEach(function (elem, index) {
            if (elem.length > 1) {
                const cardLabel = document.createElement("label");
                cardLabel.for = elem;
                cardLabel.classList.add("card");

                const cardCheckbox = document.createElement("input");
                cardCheckbox.type = "checkbox";
                cardCheckbox.name = elem;
                cardCheckbox.id = elem;

                const span = document.createElement("span");
                span.innerText = elem;
                if (elem == "DINA") {
                    span.innerText = "DinaCard";
                }
                if (elem == "Amex") {
                    span.innerText = "American Express";
                }

                cardLabel.append(cardCheckbox);
                cardLabel.append(span);

                $(".cards-list").append(cardLabel);
            }
        });

        $(".cards-list input").click(function () {
            var cliked = $(this);
            if ($(this).prop("checked")) {
                var boxes = Array.from(
                    $(".cards-list").find("input[type=checkbox]")
                );
                boxes.forEach(function (checkbox) {
                    if (cliked.attr('id') != $(checkbox).attr('id')) {
                        $(checkbox).prop('checked', false);
                    }
                });
            }
        });
    };

    this.populateTypeSelector = function (collection, selector) {
        var labelMap = [];


        var typeArray = [];
        var labelArray = [];
        collection.forEach(function (store) {
            typeArray.push(store.MCC);
        });

        typeArray = Array.from(new Set(typeArray));

        typeArray.forEach(function (elem, index) {
            var codeArray = [];
            label = MCCLabels["" + elem];
            codeArray.push(elem);
            typeArray.forEach(function (elem2, index2) {
                if (label == MCCLabels["" + elem2]) {
                    if ($.inArray(elem2, codeArray) == -1) {
                        codeArray.push(elem2);
                    }
                }
            });
            // The label is a number and must be converted to a string
            if (label != '' && label != null && $.inArray(label, labelArray) == -1) {
                labelArray.push(label);

                var singleArray = [];
                singleArray.push(label);
                singleArray.push(codeArray);
                labelMap.push(singleArray);
            }
        });

        labelMap.sort();
        for (var i = 0; i < labelMap.length; i++) {
            $(selector).append(
                $('<option value="' + labelMap[i][1] + '">', { index: i }).text(labelMap[i][0])
            );
        }

    };

    this.sortByRelevance = function () {
        function levenshtein(s, t) {
            if (!s.length) return t.length;
            if (!t.length) return s.length;

            return Math.min(
                levenshtein(s.substring(1), t) + 1,
                levenshtein(t.substring(1), s) + 1,
                levenshtein(s.substring(1), t.substring(1)) + (s[0] !== t[0] ? 1 : 0)
            );
        }

        return function (arr, str) {
            return arr.sort(function (a, b) {
                return levenshtein(a, str) - levenshtein(b, str);
            });
        };
    }

    this.populateInput = function (collection, type) {
        var arr;
        if (type == "Name") {
            arr = $.map(collection, function (elem) {
            	// + " " + elem.RetailerName2
                return { name: elem.RetailerName1 }
            });
        } else {
            arr = $.map(collection, function (elem) {
                return { name: elem.RetailerAddressLine1 }
            });
        }
        var options = {
            data: arr,
            getValue: "name",
            list: {
                match: {
                    enabled: true,
                    method: function (element, phrase) {
                        const normalizedElement = element.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        const normalizedPhrase = phrase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        var replaceThis = normalizedPhrase;
                        var regexTest = new RegExp('\\b'+replaceThis+'\\b', 'g');  
                        var found = false ;
                        if(regexTest.test(normalizedElement)){
                        	found = true;
                        } else if (normalizedElement.indexOf(normalizedPhrase) >= 0) {
                        	// in questo caso provo con indexOf
                        	if(!normalizedElement.charAt((normalizedElement.indexOf(normalizedPhrase) - 1)).match(/[a-zA-Z]/i)){
                            	console.log("filtered name " + normalizedPhrase);
                            	found = true;
                        	}
                        }
                        return found;
                        //return (normalizedElement.indexOf(normalizedPhrase) != -1);
                    }
                },
                sort: {
                    enabled: true,
                    method: function (str1, str2) {
                        console.log(str1.name + ' ' + str2.name);
                        return str1.name.length - str2.name.length;
                    }
                },
            },
            theme: "square",
            highlightPhrase: false
        };
        if (type == "Name") {
            // cambia value 
            $("#store-name").easyAutocomplete(options);
        } else {
            $("#store-address").easyAutocomplete(options);
        }
    };

    this.populate = function (collection) {
        merchantList.populateSelector(
            collection,
            "select[name=city-selector]",
            "City"
        );
        merchantList.populateSelector(
            collection,
            "select[name=installments-selector]",
            "Installment"
        );
        merchantList.populateCardsSelector(collection);
        merchantList.populateTypeSelector(
            collection,
            "select[name=type-selector]"
        );
        merchantList.populateInput(collection, "Name");
        merchantList.populateInput(collection, "Address");
        $("#filter-container").find("select").val("");
    };

    this.repopulateSelector = function (arr, selector) {
        $(selector).empty();
        arr.forEach(function (elem, index) {
            $(selector).append(
                $('<option value="' + elem + '">', { index: elem }).text(
                    labels.MAX +
                    " " +
                    elem +
                    " " +
                    merchantList.installmentString(elem.InstNoMax)
                )
            );
        });
        $(selector).prepend(
            $('<option selected disabled value="">').text(
                labels.NUMBEROFINSTALLMENTS
            )
        );
    };

    $("#search, #apply-filters").click(function () {
        var tableType = $("div[data-type-table-merchant]").attr(
            "data-type-table-merchant"
        );
        var table = $("div[data-type-table-merchant=" + tableType + "]");
        var name = $("input[name=name]").val();
        var city = $("select[name=city-selector").val();
        var address = $("input[name=address").val();

        $(".section").find("tbody")[0].innerHTML = "";

        if (name == "" && city == "" && address == "") {
        	merchantList.addElementsToTable(condensedList, table, 0, 10);
        } else {
        	merchantList.filtered = JSON.stringify(
            		merchantList.filter(name, city, address, tableType)
            );
        }
        merchantList.filtered = JSON.stringify(merchantList.extraFilter(tableType));
        $('.merchant-table')[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });

    $("#show-extra").click(function () {
        $(".extra-filters-wrapper").toggle();
        $(".icon-ic_filter").toggleClass("icn_white");
        $("#show-extra").toggleClass("icn_btn_white");
        if (screen.width <= 769) {
            $('.extra-filters-wrapper')[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        if(!$(this).hasClass("icn_btn_white")){
        	$("#search").show();
        } else {
        	$("#search").hide();
        }
    });

    $("#load-more").click(function () {
        var tableType = $("div[data-type-table-merchant]").attr(
            "data-type-table-merchant"
        );
        var table = $("div[data-type-table-merchant=" + tableType + "]");
        var tableLength = $("tbody").find("tr").length;

        if (
        		merchantList.filtered != {}
        ) {
        	merchantList.addElementsToTable(
                JSON.parse(merchantList.filtered),
                table,
                tableLength,
                tableLength + 10
            );
        	merchantList.hideShowCards();
        } else {
            //localStorage.removeItem("filtered");
        	merchantList.addElementsToTable(
                condensedList,
                table,
                tableLength,
                tableLength + 10
            );
        }
    });

    $("#multi-selector").click(function (e) {
        $(".card-list").toggle();
    });


    $("#installment:checkbox").change(function () {
        if (this.checked) {
            //$("#credit").prop("checked", true);
            //$("#debit").prop("checked", true);
        	merchantList.repopulateSelector(
        			merchantList.creditArr,
                "select[name=installments-selector]"
            );
            $("#credit").prop("checked", false);
            $("#debit").prop("checked", false);
        } else {
            $("#credit").prop("checked", false);
            $("#debit").prop("checked", false);
        }
    });



    $("#credit:checkbox").change(function () {
        var debit = $("#debit").prop("checked");
        if (this.checked) {
            $("#installment").prop("checked", false);
            $("#debit").prop("checked", false);
        }
        if (this.checked) {
        	merchantList.repopulateSelector(
        			merchantList.creditArr,
                "select[name=installments-selector]"
            );
        } else {
        	merchantList.repopulateSelector(
        			merchantList.debitArr,
                "select[name=installments-selector]"
            );
        }
    });

    $("#debit:checkbox").change(function () {
        var credit = $("#credit").prop("checked");
        if (this.checked) {
            $("#installment").prop("checked", false);
            $("#credit").prop("checked", false);
        }
        if (this.checked) {
        	merchantList.repopulateSelector(
        			merchantList.debitArr,
                "select[name=installments-selector]"
            );
        } else {
        	merchantList.repopulateSelector(
        			merchantList.creditArr,
                "select[name=installments-selector]"
            );
        }
    });

    $('.cards-list').click(function () {
        try {
            var selectedCard = $(".cards-list").find('input:checked')[0].parentNode.innerText;
        }
        catch (e) {
            console.log('empty node')
        }
        selectedCard != undefined ?
            $('#select-card-placeholder')[0].innerHTML = selectedCard :
            $('#select-card-placeholder')[0].innerHTML = originalText;
    });

    $(".select-field").click(function () {
        $(".cards-list").toggle();
    });

    $('.type-checkboxes input').change(function () {
        if ($('.type-checkboxes input:checked').length == 0) {
            if ($(this).attr('id') == 'physical') {
                $('#online').prop('checked', true);
            }
            else {
                $('#physical').prop('checked', true);
            }
        }
    });



    // $("#all-cards").on("click", function () {
    //     if (this.checked) {
    //         var boxes = Array.from(
    //             $(".cards-list").find("input[type=checkbox]")
    //         );
    //         boxes.forEach(function (checkbox) {
    //             $(checkbox).prop("checked", "true");
    //         });
    //     }
    // });

    var rotateAlert = false;
    window.onscroll = function () {
        if (
            screen.width <= 769 &&
            window.pageYOffset > 1300 &&
            rotateAlert == false
        ) {
            $("#mobile-rotate").show();
            setTimeout(function () {
                $("#mobile-rotate").hide();
            }, 3500);
            rotateAlert = true;
        }
    };

    // show multi-selector input drop-down
    $(document).mouseup(function (e) {
        var container = $(".cards-list");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
        }
    });
};

Intesa.MerchantList.getInstance = function () {
    if (!window.intesa) {
        window.intesa = new Object();
    }
    if (!window.intesa.merchantList) {
        window.intesa.merchantList = new Intesa.MerchantList();
    }

    return window.intesa.merchantList;
};
